// snackbar-service.ts
import { type BdkSnackbar } from '@breuni-ui/bdk-snackbar';

function getOrCreateSnackbar(): BdkSnackbar {
  const existing = document.querySelector('bdk-snackbar') as BdkSnackbar;
  if (existing) return existing;
  const snackbar = document.createElement('bdk-snackbar') as BdkSnackbar;
  snackbar.setAttribute('max-visible', '1');
  snackbar.setAttribute('default-duration', '5000');
  document.body.appendChild(snackbar);
  return snackbar;
}

export async function pushToSnackbar(
  title: string,
  img?: string,
  buttonText?: string,
  callbackFunction?: (id: string) => void,
  imageAltText?: string,
  disableTextMasking?: boolean,
): Promise<string | undefined> {
  if (!customElements.get('bdk-snackbar')) {
    await import('@breuni-ui/bdk-snackbar');
  }
  await customElements.whenDefined('bdk-snackbar');
  const snackbar = getOrCreateSnackbar();

  return snackbar.show({
    text: title,
    content: img ? `<img src="${img}" alt="${imageAltText}" style="width: 100%; margin-top: 4px;">` : undefined,
    actionButtonText: buttonText,
    actionButtonAction: callbackFunction,
    closeButton: !!callbackFunction,
    showTimeIndicator: true,
    disableTextMasking: disableTextMasking,
  });
}

// Bypasses BdkSnackbar's minimumDisplayTime guard via its internal hideSnackbar method.
// closeSnackbarById defers dismissal until minimumDisplayTime (20s for action-button snackbars)
// has elapsed, which is too late for rollback scenarios.
export function dismissSnackbar(id: string) {
  const snackbar = document.querySelector('bdk-snackbar') as BdkSnackbar;
  if (!snackbar) return;
  (
    snackbar as unknown as { hideSnackbar(id: string, forceRemove: boolean, skipMinimumDisplayTime: boolean): void }
  ).hideSnackbar(id, false, true);
}
